export const getQuillPlaintext = (v: string): string => {
  const parser = new DOMParser()
  const { textContent } = parser.parseFromString(v, 'text/html').documentElement
  return textContent.trim()
}

export const titleToFilename = (v: string): string => (
  v.replace(/[^a-zA-Z0-9\-_]/g, '')
)

export const isQuillEmpty = (v: string): boolean => {
  const text = getQuillPlaintext(v)
  return !text
}
